import React, { FC, useState } from 'react'
import { updateUser } from '../../api/usersApi'
import { UserType } from '../../model/usersModel'
import {
  InputEditorButton,
  InputEditorContainer,
  InputEditorHolder,
  InputEditorInput,
} from './InputEditor.styles'

interface Props {
  user: UserType
  value: string
  userKey: string
  botId: string
  refreshUsers: () => void
  /** When true, show the value as plain text (no inline edit). Used for QCS bots. */
  readOnly?: boolean
}

export const InputEditor: FC<Props> = ({
  user,
  value,
  userKey,
  refreshUsers,
  readOnly = false,
}) => {
  const [isInputOpen, setIsInputOpen] = useState(false)
  const [inputValue, setInputValue] = useState(value)

  const onChangeHandler = (e) => {
    const value = e.target.value
    setInputValue(value)
  }

  const onBlurHandler = () => {
    if (value !== inputValue) {
      const userData = {
        ...user,
        [userKey]: inputValue
      }
      updateUser(userData).then(() => {
        refreshUsers()
      })
    }
    setIsInputOpen(false)
  }

  if (readOnly) {
    return (
      <InputEditorContainer>
        <InputEditorButton as="span">{value}</InputEditorButton>
      </InputEditorContainer>
    )
  }

  return (
    <InputEditorContainer>
      {isInputOpen ? (
        <InputEditorHolder>
          <InputEditorInput
            type='text'
            data-autotest={'atom-name-input'}
            onBlur={onBlurHandler}
            onChange={onChangeHandler}
            value={inputValue}
            autoFocus
          />
        </InputEditorHolder>
      ) : (
        <InputEditorButton
          type="button"
          $editable
          onClick={() => {
            setInputValue(value || '')
            setIsInputOpen(true)
          }}
        >
          {value}
        </InputEditorButton>
      )}
    </InputEditorContainer>
  )
}
